module.exports = __webpack_public_path__ + "static/media/ap.af238351.png";